import { Text } from '@qonsoll/react-design'
import styled from 'styled-components'

export const StyledText = styled(Text)`
  font-size: 60px;
  line-height: 80px;
  color: var(--ql-color-black);
`
